















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import TenantEnginePlugin from "../TenantEnginePlugin.vue";

import { ContentSection, SectionOverview } from "sitewhere-ide-components";
import { VCard, VTextField } from "vuetify/lib";

import { ITenantEngineConfiguration } from "sitewhere-rest-api";
import { IInboundProcessingConfiguration } from "sitewhere-configuration-model";

@Component({
  components: {
    VCard,
    VTextField,
    ContentSection,
    TenantEnginePlugin,
    SectionOverview
  }
})
export default class InboundProcessingPlugin extends Vue {
  @Prop() readonly configuration!: ITenantEngineConfiguration;

  processingThreadCount = 10;

  /** Get tenant configuration for inbound processing */
  get inboundProcessing(): IInboundProcessingConfiguration {
    return this.configuration ? this.configuration.tenantConfiguration : null;
  }

  @Watch("inboundProcessing", { immediate: true })
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  onConfigurationUpdated(updated: IInboundProcessingConfiguration) {
    this.processingThreadCount = updated.processingThreadCount;
  }

  @Watch("processingThreadCount")
  onProcessingThreadCountUpdated(updated: number) {
    this.inboundProcessing.processingThreadCount = updated;
    this.markDirty();
  }

  /** Mark data as having been updated */
  markDirty(): void {
    this.$emit("dirty");
  }
}
